'use strict';

angular.module('licensure.internal')
    .controller(
        'InternalTimeoutNotifyModalController', function ($scope, logout, stayLoggedIn) {
            $scope.logout = logout;
            $scope.stayLoggedIn = stayLoggedIn;
    })